"use client";

import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { useEffect, useState } from "react";
import { LiaCookieBiteSolid } from "react-icons/lia";

type Props = {
  href: string;
};

export default function FacebookPagePlugin({ href }: Props) {
  const { cookieConsent, setShowCookieConsentPopup } = useCookieConsent();
  const [showPlaceHolder, setShowPlaceHolder] = useState(false);

  useEffect(() => {
    if (!cookieConsent || cookieConsent === "accepted") {
      window.fbAsyncInit = function () {
        FB.init({
          xfbml: true,
          version: "v18.0",
        });
        FB.XFBML.parse();
      };

      // Load the SDK script if not already present
      if (!document.getElementById("facebook-jssdk")) {
        const script = document.createElement("script");
        script.id = "facebook-jssdk";
        script.src = "https://connect.facebook.net/hu_HU/sdk.js";
        document.body.appendChild(script);
      } else if (window.FB) {
        // parse page again
        setTimeout(() => {
          FB.XFBML.parse();
        });
      }

      setShowPlaceHolder(false);
    } else {
      setShowPlaceHolder(true);
    }
  }, [cookieConsent]);

  return (
    <>
      <div className="flex justify-center mx-4">
        <div className="overflow-y-auto rounded-4xl shadow-md">
          {!showPlaceHolder && (
            <div
              className="fb-page"
              data-href={href}
              data-width="500"
              data-height="500"
              data-show-posts="true"
              data-small-header="false"
              data-adapt-container-width="true"
              data-hide-cover="false"
              data-show-facepile="true"
            ></div>
          )}

          {showPlaceHolder && (
            <div className="flex flex-col justify-center items-center p-8 max-w-full w-[500px] h-[500px] bg-secondary">
              <LiaCookieBiteSolid size={124} className="text-salmon mb-8" />
              <p className="mb-8 text-center">
                Behemke Facebook oldal nem tölt be, mert a sütik el lettek
                utasítva.
              </p>
              <button
                className="button-outlined px-4"
                onClick={() => setShowCookieConsentPopup(true)}
              >
                Mégis elfogadnám a sütiket
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
